@if (template$ | async; as template) {
  <div>
    @if (template?.['metaData']) {
      <sfo-dynamic-form
        [jsonSchema]="template?.['metaData']"
        (formValue)="updateExportMetadata($event)"
        [patchForm]="metaData$ | async"
        >
      </sfo-dynamic-form>
    }
  </div>
}
